import { Modal, ModalFuncProps } from "antd";
import React from "react";

interface Props extends ModalFuncProps {
  children: React.ReactElement;
  disabled?: boolean;
}

export const ConfirmModal = ({ children, ...restProps }: Props) => {
  const onClick = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      ...restProps,
    });
  };

  return React.cloneElement(children, { onClick });
};
